import http from "@/api/http-common";
import { addSseEventListeners, closeSseClient, createSseClient, startSseMonitor, stopSseMonitor } from "@/api/sse-client";

export function subscribeForWalletSse(userType, user) {
  return http.getApiClient(userType).get("", {
    params: {
      a: "set_sse",
      id: user.id,
      key: user.key,
      "quote-ex-sts": "off",
      "quote-tr-sts": "off",
      "depth-sts": "off",
      "top10-sts": "off",
      "top10-set": "",
      "top10-typ": "",
      "wallet-sts": "on",
      "phase-sts": "off",
      "quote-sts": "off",
      "quote-set": ""
    }
  });
}

export function setupWalletStream(options) {
  const client = createSseClient(options.userType, options.user);
  if (!client) {
    return null;
  }

  addSseEventListeners(client, {
    HEARTBEAT: () => options.onHeartbeat?.(),
    SESSION_CLOSED: () => options.onSessionClosed?.(),
    WALLET: event => options.onWallet?.(event),
    EXECUTED: event => options.onExecuted?.(event),
    REJECTED: event => options.onRejected?.(event),
    QUOTE_TR: event => options.onQuoteTrading?.(event),
    DEPTH: event => options.onDepth?.(event),
    error: event => options.onError?.(event)
  });

  return client;
}

export function startWalletSseMonitor(options) {
  return startSseMonitor(options);
}

export function stopWalletSseMonitor(verifier) {
  stopSseMonitor(verifier);
}

export function closeWalletSseClient(client) {
  closeSseClient(client);
}
